import Vue from 'vue'
import store from '@/store'

Vue.config.errorHandler = function (err, vm, info) {
  console.error(err)
  store.dispatch('addErrorLogs', {
    message: err.message,
    stack: err.stack
  })
}
/**
 * Promise未catch的错误、async/await未使用try/catch捕获
 */
window.addEventListener('unhandledrejection', (e) => {
  // console.log('unhandledrejection：',e)
  throw e.reason
})
/**
 * 同步方法错误、异步方法错误、资源加载错误
 */
window.addEventListener(
  'error',
  (args) => {
    const error = args.error || args
    let message = args.message || error.message
    let stack = error.stack

    // 资源加载出错
    const target = args.target || {}
    const isElementTarget =
      target instanceof HTMLScriptElement ||
      target instanceof HTMLLinkElement ||
      target instanceof HTMLImageElement
    if (isElementTarget) {
      message = '资源加载出错'
      stack = target.src || target.href
    }

    // 此类错误不处理
    if (/^ResizeObserver.*/.test(message)) {
      return
    }
    if (stack) {
      store.dispatch('addErrorLogs', {
        message,
        stack
      })
    }
  },
  true
)

// 发送错误日志
store.dispatch('sendErrorLogs')
